<template>
  <div>
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-bottom:10px"
    >

      <el-breadcrumb-item>密码重置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="账号"
          prop="username"
        >
          <el-input
            v-model="ruleForm.username"
            style="width:230px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="旧密码"
          prop="oldPassword"
        >
          <el-input
            v-model="ruleForm.oldPassword"
            style="width:230px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPassword"
        >
          <el-input
            v-model="ruleForm.newPassword"
            style="width:230px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="newPasswordSecond"
        >
          <el-input
            v-model="ruleForm.newPasswordSecond"
            style="width:230px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
          <el-button
            type="primary"
            style="margin:0 0 0 85px"
            @click="submitForm('ruleForm')"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";
import { mapState } from "vuex";
export default {
  data () {
    return {
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        newPasswordSecond: '',
        username: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },

        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        newPasswordSecond: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],

      }

    }
  },
  methods: {
    //重置
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    //提交
    submitForm (ruleForm) {
      var that = this;
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (that.ruleForm.newPassword == that.ruleForm.newPasswordSecond) {


            var userData = qs.parse(sessionStorage.getItem("userData"));
            let config = {
              "Content-Type": "multipart/form-data"
            };
            var updateMemberData = {
              lx: 2,
              user_name: that.ruleForm.username,//账号
              pass: that.ruleForm.oldPassword,//旧密码
              new_pass: that.ruleForm.newPassword,//新密码
            };

            var updateMemberParams = {
              methodUrl: "admin/webLogin",
              jsonParam: qs.stringify(updateMemberData)
            };

            this.$axios.postRequest(updateMemberParams).then(
              function (res) {
                //成功之后处理逻辑
                if (res.code == -1001) {
                  that.$message({
                    message: res.msg,
                    type: 'warning'
                  });

                } else {

                  that.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                }




              },
              function (res) {
                //失败之后处理逻辑
                console.log("error:" + res);
              }
            );
          } else {
            that.$message({
              message: '两次密码不一致',
              type: 'warning'
            });
            that.resetForm(ruleForm);
          }
        } else {
          that.$message({
            message: '请将信息填写完整',
            type: 'warning'
          });
        }
      });
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/password.vue